





































































import {Component, Mixins, Ref} from 'vue-property-decorator';
import {Mixin} from "@/mixins";
import store from '@/store';
import NiceCheckbox from "@/components/NiceCheckbox.vue";
import NiceSelect from "@/components/NiceSelect.vue";

@Component({
    components: {
        NiceSelect,
        NiceCheckbox,
    }
})
export default class CartOptions extends Mixins(Mixin) {
    //<editor-fold desc="Private properties">
    store = store();
    //</editor-fold>

    //<editor-fold desc="Props">
    //</editor-fold>

    //<editor-fold desc="Refs">
    @Ref()
    zipcodeInput?: HTMLInputElement;
    //</editor-fold>

    //<editor-fold desc="Watchers">
    //</editor-fold>

    //<editor-fold desc="Getters">
    get countriesForSelect() {
        let ret: { [key: string]: string } = {};
        for (let [key, country] of Object.entries(this.store.availableCountries!)) {
            if (
                typeof this.store.serverData.additionalOptions.assemblyData.countries === 'undefined'
                || this.store.serverData.additionalOptions.assemblyData.countries.length === 0
                || (
                  typeof this.store.serverData.additionalOptions.assemblyData.countries !== 'undefined'
                  && this.store.serverData.additionalOptions.assemblyData.countries.includes(country.code)
                )
            ) {
              ret[key] = country.name;
            }
        }
        return ret;
    }

    get showAssemblyInputs() {
        return this.store.serverData.additionalOptions.assembly;
    }
    //</editor-fold>

    //<editor-fold desc="Hooks">
    //</editor-fold>

    //<editor-fold desc="Methods">
    async toggleAssembly() {
        if (this.store.isPreview || (this.store.serverData.personalizedCart && this.store.serverData.personalizedCart.mandatoryAssembly)) {
            return;
        }

        this.store.serverData.additionalOptions.assembly = !this.store.serverData.additionalOptions.assembly;

        await this.store.syncServer();

        if (this.store.serverData.additionalOptions.assemblyData) {
            if (this.zipcodeInput) {
                this.zipcodeInput.focus();
            }
        } else {
            this.store.showAssemblyZipError = false;
            this.store.removeError('billingAddress.zipcode');
        }
    }

    async editAssembly() {
        this.store.assemblyConfirmed = false;
        await this.$nextTick();

        if (this.zipcodeInput) {
            this.zipcodeInput.focus();
        }
    }
    //</editor-fold>
}
